module.exports = __webpack_public_path__ + "static/media/IMG_8017.e7dbea96.jpg";